// extracted by css-extract-rspack-plugin
export default {"locator":"qNZPSnm52E87Cw2s","in":"Ydjb4UmOAgs4UZgA","pkg":"B5MRDH1djcqDr7if"};